import * as SignIn_en from './SignIn.en.js';
import * as SignIn_es from './SignIn.es.js';

const SignInTuple = [
  { type: 'SignIn', language: 'en', object: SignIn_en.default },
  { type: 'SignIn', language: 'es', object: SignIn_es.default },
];

export default SignInTuple;
